export const PHONE_NUMBER = "919004994052";

export function sendToWhatsApp(message) {
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${PHONE_NUMBER}?text=${encodedMessage}`;
  window.open(whatsappUrl, "_blank");
}

function getProjectDetails(button) {
  const projectCard = button.closest(".project-mas") || button.closest(".card");
  let projectTitle = "a project";
  let projectLocation = "Mumbai";

  if (projectCard) {
    const titleEl = projectCard.querySelector("h4");
    if (titleEl) {
      projectTitle = titleEl.textContent.trim();
    }

    const detailItems = projectCard.querySelectorAll(".detail-item");
    detailItems.forEach(function (item) {
      const icon = item.querySelector("i");
      if (icon && icon.classList.contains("fa-map-marker")) {
        projectLocation = item.textContent.trim();
      }
    });
  }

  return `Hello Shree Mahavir Group,

I'm interested in "${projectTitle}" project at "${projectLocation}". Please provide more details.

Thank you!`;
}

export function initWhatsAppEnquiry() {
  const enquiryButtons = document.querySelectorAll(".btn-enquire");

  enquiryButtons.forEach(function (button) {
    if (button.dataset.waBound) {
      return;
    }
    button.dataset.waBound = "true";

    const projectMessage = getProjectDetails(button);

    const handleClick = function (e) {
      e.preventDefault();
      sendToWhatsApp(projectMessage);
    };

    button.addEventListener("click", handleClick);

    const anchor = button.querySelector("a");
    if (anchor) {
      anchor.addEventListener("click", handleClick);
    }
  });

  const contactForm = document.getElementById("contactForm");
  if (contactForm && !contactForm.dataset.waBound) {
    contactForm.dataset.waBound = "true";
    contactForm.addEventListener("submit", function (e) {
      e.preventDefault();
      const name = document.getElementById("name")?.value || "";
      const phone = document.getElementById("phone")?.value || "";
      const email = document.getElementById("email")?.value || "";
      const query = document.getElementById("query")?.value || "";

      const contactMessage = `Hello Shree Mahavir Group,

*NEW CONTACT ENQUIRY*

*Personal Details:*
• Name: ${name}
• Phone: ${phone}
• Email: ${email}

*Query:*
${query}

Please contact me regarding this enquiry.

Thank you!`;

      sendToWhatsApp(contactMessage);
    });
  }

  const careerForm = document.getElementById("careerForm");
  if (careerForm && !careerForm.dataset.waBound) {
    careerForm.dataset.waBound = "true";
    careerForm.addEventListener("submit", function (e) {
      e.preventDefault();
      const name = document.getElementById("candidateName")?.value || "";
      const phone = document.getElementById("candidatePhone")?.value || "";
      const email = document.getElementById("candidateEmail")?.value || "";
      const position = document.getElementById("candidatePosition")?.value || "";
      const experience = document.getElementById("candidateExperience")?.value || "";
      const subject = document.getElementById("candidateSubject")?.value || "";
      const messageText = document.getElementById("candidateMessage")?.value || "";
      const resume = document.getElementById("candidateResume")?.value || "";

      let careerMessage = `Hello Shree Mahavir Group,

*CAREER ENQUIRY - SHREE MAHAVIR GROUP*

*Personal Details:*
• Name: ${name}
• Phone: ${phone}
• Email: ${email}

*Job Details:*
• Position: ${position}
• Subject: ${subject}
• Experience: ${experience}`;

      if (resume) {
        careerMessage += `
• Resume Link: ${resume}`;
      }

      if (messageText) {
        careerMessage += `

*Additional Message:*
${messageText}`;
      }

      careerMessage += `

Thank you!`;

      sendToWhatsApp(careerMessage);
    });
  }

  const siteVisitForm = document.getElementById("siteVisitForm");
  if (siteVisitForm && !siteVisitForm.dataset.waBound) {
    siteVisitForm.dataset.waBound = "true";
    siteVisitForm.addEventListener("submit", function (e) {
      e.preventDefault();
      const name = document.getElementById("name")?.value || "";
      const phone = document.getElementById("phone")?.value || "";
      const email = document.getElementById("email")?.value || "";
      const date = document.getElementById("date")?.value || "";
      const unit = document.getElementById("unit")?.value || "";
      const time = document.getElementById("time")?.value || "";
      const message = document.getElementById("message")?.value || "";

      let siteVisitMessage = `Hello Shree Mahavir Group,

*NEW SITE VISIT BOOKING - PARK GRANDEUR*

*Personal Details:*
• Name: ${name}
• Phone: ${phone}
• Email: ${email}

*Visit Details:*
• Preferred Date: ${date}
• Interested Unit: ${unit}
• Preferred Time: ${time || "Not specified"}`;

      if (message) {
        siteVisitMessage += `

*Additional Message:*
${message}`;
      }

      siteVisitMessage += `

Please confirm my site visit booking.

Thank you!`;

      sendToWhatsApp(siteVisitMessage);
    });
  }
}

export default sendToWhatsApp;